export const environment = {
  production: true,
  defaultLanguage: 'en-US',
  supportedLanguages: [{
    'code': 'en-US',
    'name': 'English'
  }, {
    'code': 'fr-FR',
    'name': 'French'
  },
  {
    'code': 'es-ES',
    'name': 'Spanish'
  },
  {
    'code': 'it-IT',
    'name': 'Italian'
  },
  {
    'code': 'de-DE',
    'name': 'German'
  },
  {
    'code': 'ru-RU',
    'name': 'Russian'
  }
  ],
  title: 'EcoStruxure Eliwell AIR',
  logo: 'assets/schneider_LIO_Life-Green_RGB.png',
  logo_black: 'assets/schneider_LIO_Black_RGB.png',
  image: 'assets/woman.png',
  DateFormat: 'MM/dd/yyyy',
  DateFormatDMY: 'dd/MM/yyyy',

  //CAF-DEV
  industry_services_version: '2.0',
  client_id: 'cc52bf28bfa24a2686fd2b0ac48884b5',

  Ocp_Apim_Trace: 'true',
  Ocp_Apim_Subscription_Key: 'cc52bf28bfa24a2686fd2b0ac48884b5',
  DateTimeFormat: 'yyyy/MM/dd HH:mm:ss',
  // Export Page configs
  NumberOfdays : 30,
  NumberOfCoolers : 30,
  ChunkSize: 10,
  termsOfPurchaseUrl: 'https://www.eliwell.com/en/About-us/Terms-of-Purchase-and-Sale.html',
  //QA
  redirect_uri: 'https://qa-air.eliwell.com',
  serverUrl: 'https://qa-air.eliwell.com/service/api',
  supportUrl:'http://www.schneider-electric.com/b2b/en/support/',
  faqsUrl:'http://www.schneider-electric.com/en/faqs/home/',
  legalUrl:'https://qa-air.eliwell.com/terms',
  privacypolicyUrl:'https://qa-air.eliwell.com/terms',
  copyrightUrl:'https://www.schneider-electric.com/en/about-us/legal/legal-information.jsp',
  facebookUrl:'https://www.facebook.com/SchneiderElectric?brandloc=DISABLE',
  twitterUrl:'https://twitter.com/SchneiderElec',
  youtubeUrl:'https://www.youtube.com/user/SchneiderCorporate',
  //Services
  telemetryRefresh: 180000,
  commandsPollInterval: 3000,
  forExpo: true
  //statistics: StatsService //actual
};
